import { RouteType } from "types/RouteType";
// import dailyQRCodeRoute from "./DailyQRCode/dailyQRCode.Route";
// import fieldActivityOverviewRoute from "./FieldActivityOverview/fieldActivityOverview.Route";
// import fieldActivityTrackerRoute from "./FieldActivityTracker/fieldActivityTracker.Route";
// import hardwareFloorTrackerRoute from "./HardwareFloorTracker/hardwareFloorTracker.Route";
// import hardwareOrdersRoute from "./HardwareOrders/hardwareOrders.Route";
// import hardwareOverviewRoute from "./HardwareOverview/hardwareOverview.Route";
import ifcTrackerRoute from "./IFCTracker/ifcTracker.Route";
// import qrCodeRoute from "./QRCode/qrCode.Route";
// import panelYardManagementRoute from "./PanelYardManagement/PanelYardManagement.Route";

const inventoryAndFieldRoutesList: RouteType[] = [
  // ...dailyQRCodeRoute,
  // ...fieldActivityOverviewRoute,
  //   fieldActivityTrackerRoute,
  //   hardwareFloorTrackerRoute,
  // ...hardwareOrdersRoute,
  // ...hardwareOverviewRoute,
  ...ifcTrackerRoute,
  // qrCodeRoute,
  //   panelYardManagementRoute,
];

export default inventoryAndFieldRoutesList;
